import apiClient from '../../../Services/ApiClient';
import { QuestionnaireItemResultColoring } from '../Components/QuestionnairePreview/QuestionnairePreview';

export const getQuestionnaireTree = async (questionnaireId: string) => {
	return await apiClient.get(`questionnaire/${questionnaireId}/tree`);
};

export const rangeGenerator = (start: number, stop: number, step: number) =>
	Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);

export const getColorsByValue = (
	value: string | number,
	resultColoring?: QuestionnaireItemResultColoring,
) => {
	return resultColoring?.children?.find(item => {
		return item?.conditions?.find(e => {
			const val = typeof value === 'string' ? parseInt(value) : value;
			switch (true) {
				case e?.equal === val:
					return item;
				case e?.smallerOrEqual && e?.smallerOrEqual >= val && !e?.biggerOrEqual:
					return item;
				case e?.biggerOrEqual && e?.biggerOrEqual <= val && !e?.smallerOrEqual:
					return item;
				case e?.smallerOrEqual &&
					e?.smallerOrEqual >= val &&
					e?.biggerOrEqual &&
					e?.biggerOrEqual <= val:
					return item;
				default:
					return undefined;
			}
		});
	});
};
